import { DsbcApiOptions } from '../_dsapi/DsbcApiOptions';
import { createDsbcApiUrl } from '../createDsbcApiUrl';
import { DsbcApi } from '../createDsbcRequest';
import { BaseRequest, BaseResponse } from '../shared';

interface setViewedRequest extends BaseRequest {
  invId: string; //邀请活动ID ,
  rewardIndex: string; //奖励内容
}

export interface ApiNullVO {}

interface setViewedResponse extends BaseResponse {
  Data: ApiNullVO[];
}

/**
 *POST /inv/setViewed
消除奖励弹窗，需要传入邀新活动ID
 * @param params
 * @returns
 */
export async function setViewed(request: setViewedRequest, options?: DsbcApiOptions) {
  const url = await createDsbcApiUrl('/inv/setViewed');
  return DsbcApi.fetch<setViewedResponse>(url, request, true, options);
}
